import { createStyles, makeStyles, Theme } from '../../../MaterialUI'

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      maxWidth: '345px',
      borderRadius: '16px',
      textAlign: 'center',
    },
    input: {
      width: '100%',
      height: '48px',
      marginTop: '4px',
      paddingLeft: '20px',
      borderRadius: '8px',
      border: '2px solid var(--border-color)',
      color: 'var(--text-color)',
      fontFamily: 'LatoNormal',
      fontWeight: 400,
      '& .MuiInput-underline:before': {
        borderBottomColor: '#FFF',
      },
      '& .MuiInput-underline:hover:before': {
        borderBottomColor: '#FFF',
      },
      '& .MuiInput-underline:after': {
        borderBottomColor: '#FFF',
      },
      '&.Mui-focused': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--border-color-focus)',
          borderRadius: 8,
        },
      },
      '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'var(--border-color-focus)',
          borderRadius: 8,
        },
      },
    },
    submit: {
      textTransform: 'none',
      color: 'var(--white-color)',
      backgroundColor: 'var(--bosscat-blue-600)',
      borderRadius: 8,
      height: '44px',
      fontFamily: 'LatoNormal',
    },
    logo: {
      zIndex: 1500,
      position: 'fixed',
      width: '60px',
    },
    logoContainer: {
      marginLeft: '95px',
      marginTop: '-60px',
      zindex: 1500,
      position: 'fixed',
      width: '100px',
      height: '100px',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: 'white',
      borderRadius: '50%',
      // border: '2px solid var(--bosscat-blue-600)'
    },
    header: {
      background: 'var(--background-color-secondary)',
    },
    headerText: {
      paddingTop: '36px',
    },
    headerTX: {
      color: 'rgba(114, 116, 141, 1)',
    },
    inputNumber: {
      margin: 0,
      borderRadius: '8px 8px 0 0',
    },
    inputDate: {
      borderTop: '0px',
      borderRight: '0px',
      marginTop: '-1px',
      borderRadius: '0 0 0 8px',
    },
    inputCVV: {
      borderTop: '0px',
      marginTop: '-1px',
      borderRadius: '0 0 8px 0',
    },
    check: {
      display: 'grid',
      justifyContent: 'end',
    },
    checkText: {
      color: 'rgba(114, 116, 141, 1)',
    },
    errorMessage: {
      display: 'flex',
      gap: '8px',
      alignItems: 'center',
      marginTop: '16px',
      padding: '8px 16px',
      borderRadius: '8px',
      background: 'var(--expired-color-back)',
    },
    errorColor: { borderColor: 'var(--error-color)' },
    errorTopColor: { borderTopColor: 'var(--error-color)' },
    errorBottomColor: { borderBottomColor: 'var(--error-color)' },
    errorLeftColor: { borderLeftColor: 'var(--error-color)' },
    errorRightColor: { borderRightColor: 'var(--error-color)' },
    spinner: {
      '& .MuiCircularProgress-circle': {
        color: 'var(--white-color)',
      },
    },
  })
)
